var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _circle2, _circle3, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphoneAndLupa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 116,
    viewBox: "0 0 131 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.836 75.7498C120.992 74.9647 120.49 74.463 119.705 71.6187C119.606 71.2604 119.281 71.0127 118.909 71.0127C118.537 71.0127 118.212 71.2602 118.113 71.6187C117.328 74.463 116.826 74.9647 113.982 75.7498C113.624 75.8488 113.375 76.1743 113.375 76.5461C113.375 76.9177 113.624 77.243 113.982 77.3423C116.826 78.1274 117.328 78.6292 118.113 81.4733C118.212 81.8312 118.537 82.0796 118.909 82.0796C119.281 82.0796 119.607 81.8312 119.705 81.4733C120.49 78.629 120.992 78.1272 123.836 77.3423C124.195 77.2433 124.442 76.9177 124.442 76.5461C124.442 76.1745 124.194 75.849 123.836 75.7498Z",
    fill: "#977BD2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.7725,
    cy: 53.8467,
    r: 53.8467,
    fill: "#D3E1FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4645 8.08927L4.2168 17.6797L22.3913 99.6371L65.639 90.0467L47.4645 8.08927Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64329 20.9361L19.3017 100.566C19.9984 103.708 23.1261 105.7 26.2678 105.004L64.3956 96.5485C67.5374 95.8518 69.5297 92.7242 68.833 89.5824L51.1746 9.95226C50.4779 6.8105 47.3502 4.81823 44.2085 5.51493L6.08062 13.97C2.93886 14.6667 0.94659 17.7943 1.64329 20.9361ZM48.0974 10.7567L64.5602 84.9955C65.1795 87.7881 63.4287 90.5367 60.6361 91.156L27.4342 98.5186C24.6415 99.1379 21.893 97.3872 21.2737 94.5945L4.81086 20.3558C4.48401 18.8818 5.41978 17.4128 6.89369 17.0859L12.5178 15.8388C13.6427 15.5893 14.7326 16.2836 14.982 17.4084C15.3089 18.8823 16.7779 19.8181 18.2518 19.4913L35.4734 15.6723C36.9473 15.3454 37.883 13.8764 37.5562 12.4025C37.3068 11.2777 38.001 10.1877 39.1259 9.93829L44.75 8.6911C46.2239 8.36425 47.693 9.30002 48.0198 10.7739L48.0974 10.7567Z",
    fill: "#4E2D92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3198 80.4714L30.954 85.4312C30.1552 85.6083 29.3682 85.107 29.1911 84.3082C29.0139 83.5094 29.5153 82.7224 30.314 82.5453L52.6798 77.5855C53.4786 77.4084 54.2656 77.9097 54.4427 78.7085C54.6199 79.5073 54.1185 80.2943 53.3198 80.4714Z",
    fill: "#4E2D92"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.32 81.3317C49.2685 81.3431 49.1912 81.3603 49.1396 81.3717L30.8193 85.4343C30.0978 85.5943 29.3738 85.1331 29.2138 84.4116L29.1566 84.154C28.9967 83.4325 29.4579 82.7084 30.1794 82.5484L47.9586 78.6058L49.3143 81.3059L49.32 81.3317Z",
    fill: "#977BD2",
    fillOpacity: 0.51
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4401 81.9969L46.0021 82.0941L44.6406 79.3682L45.0787 79.271L46.4401 81.9969Z",
    fill: "#4E2D92"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5475 81.7508L47.1095 81.848L45.748 79.1221L46.1861 79.0249L47.5475 81.7508Z",
    fill: "#4E2D92"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6569 81.5057L48.2189 81.6029L46.8574 78.877L47.2955 78.7798L48.6569 81.5057Z",
    fill: "#4E2D92"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.217 73.5157L33.3138 69.4431L34.9894 69.0715C35.3502 68.9915 35.6714 68.9813 35.9532 69.0409C36.2389 69.0996 36.4756 69.2221 36.6634 69.4084C36.8512 69.5946 36.9783 69.8371 37.0445 70.1357C37.1107 70.4344 37.0981 70.7078 37.0066 70.956C36.9152 71.2041 36.7524 71.4152 36.5183 71.5892C36.2881 71.7623 35.9927 71.8889 35.632 71.9689L34.3753 72.2476L34.634 71.8178L34.9733 73.348L34.217 73.5157ZM34.6521 71.8993L34.2333 71.6076L35.4551 71.3366C35.7887 71.2627 36.0234 71.1374 36.1592 70.9608C36.2981 70.7794 36.3391 70.5607 36.2823 70.3047C36.2247 70.0449 36.0951 69.864 35.8934 69.7622C35.6957 69.6596 35.43 69.6452 35.0965 69.7192L33.8747 69.9902L34.1295 69.543L34.6521 71.8993ZM38.3817 72.5922L37.4785 68.5195L38.2349 68.3518L39.138 72.4244L38.3817 72.5922ZM39.7451 72.2898L40.9376 69.5471L41.064 70.1173L38.9234 68.1991L39.7786 68.0095L41.3688 69.4271L41.021 69.5103L41.8499 67.5501L42.6702 67.3682L41.5437 69.9682L41.4224 69.4213L43.6781 71.4177L42.8054 71.6112L41.128 70.1031L41.4713 70.0269L40.6061 72.0989L39.7451 72.2898Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1613 25.621L15.6113 31.9521L21.9424 60.5021L50.4924 54.171L44.1613 25.621Z",
    fill: "#977BD2",
    fillOpacity: 0.51
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1152 34.1523L20.3576 39.7546L25.9598 38.5123L24.7175 32.91L19.1152 34.1523ZM24.6436 37.6738L21.196 38.4383L20.4315 34.9908L23.879 34.2263L24.6436 37.6738Z",
    fill: "#362D47"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2568 35.1561L21.3535 35.5781L21.7756 37.4815L23.6789 37.0594L23.2568 35.1561Z",
    fill: "#362D47"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9297 51.3535L24.172 56.9558L29.7743 55.7134L28.5319 50.1112L22.9297 51.3535ZM28.458 54.875L25.0105 55.6395L24.246 52.192L27.6935 51.4275L28.458 54.875Z",
    fill: "#362D47"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0713 52.3572L25.168 52.7793L25.59 54.6826L27.4934 54.2606L27.0713 52.3572Z",
    fill: "#362D47"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1523 47.46L41.3867 53.0263L46.989 51.784L45.7546 46.2176L40.1523 47.46ZM45.6807 50.9814L42.2331 51.746L41.4686 48.2984L44.9162 47.5339L45.6807 50.9814Z",
    fill: "#362D47"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.292 48.4637L42.3887 48.8857L42.8107 50.7891L44.7141 50.367L44.292 48.4637Z",
    fill: "#362D47"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 40.8594L30.8869 46.4616L36.4532 45.2273L35.2109 39.625L29.6445 40.8594ZM35.1729 44.3809L31.7253 45.1454L30.9608 41.6978L34.4083 40.9333L35.1729 44.3809Z",
    fill: "#362D47"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7861 41.8631L31.8828 42.2852L32.3049 44.1885L34.2082 43.7664L33.7861 41.8631Z",
    fill: "#362D47"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9193 29.095L27.375 32.3203L27.7811 34.1518L42.3255 30.9265L41.9193 29.095Z",
    fill: "#362D47"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1882 43.6674L41.9629 29.123L40.1314 29.5292L43.3567 44.0735L45.1882 43.6674Z",
    fill: "#362D47"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8343 51.9765L31 53.9355L31.3026 55.3002L40.137 53.3411L39.8343 51.9765Z",
    fill: "#362D47"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3269 49.8649L34.3711 50.9639L34.6737 52.3285L39.6296 51.2295L39.3269 49.8649Z",
    fill: "#362D47"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6418 40.4496L20.5645 40.6885L22.4837 49.3433L23.5611 49.1043L21.6418 40.4496Z",
    fill: "#362D47"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2059 40.643L21.8965 41.5986L22.1035 42.5323L26.413 41.5767L26.2059 40.643Z",
    fill: "#362D47"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9618 44.0541L22.6523 45.0098L22.939 46.3026L27.2485 45.347L26.9618 44.0541Z",
    fill: "#362D47"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9033 36.574L26.4668 36.8926L26.7853 38.3291L28.2218 38.0105L27.9033 36.574Z",
    fill: "#362D47"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8154 34.1443L26.3789 34.4629L26.6975 35.8994L28.1339 35.5808L27.8154 34.1443Z",
    fill: "#362D47"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6025 35.7537L30.166 36.0723L30.4846 37.5087L31.921 37.1902L31.6025 35.7537Z",
    fill: "#362D47"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.413 41.577L24.9766 41.8955L25.2951 43.332L26.7316 43.0134L26.413 41.577Z",
    fill: "#362D47"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2099 45.1678L25.7734 45.4863L26.092 46.9228L27.5285 46.6043L27.2099 45.1678Z",
    fill: "#362D47"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1162 47.0311L24.6797 47.3496L24.9982 48.7861L26.4347 48.4675L26.1162 47.0311Z",
    fill: "#362D47"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5126 49.451L30.0762 49.7695L30.3947 51.206L31.8312 50.8875L31.5126 49.451Z",
    fill: "#362D47"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8955 47.7391L37.459 48.0576L37.7775 49.4941L39.214 49.1755L38.8955 47.7391Z",
    fill: "#362D47"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8369 46.9422L33.4004 47.2607L33.7189 48.6972L35.1554 48.3787L34.8369 46.9422Z",
    fill: "#362D47"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1806 49.0936L34.7441 49.4121L35.0627 50.8486L36.4992 50.53L36.1806 49.0936Z",
    fill: "#362D47"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2529 50.4969L31.8164 50.8154L32.135 52.2519L33.5714 51.9334L33.2529 50.4969Z",
    fill: "#362D47"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0537 46.2703L28.6172 46.5889L28.9357 48.0253L30.3722 47.7068L30.0537 46.2703Z",
    fill: "#362D47"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0498 41.7459L27.6133 42.0645L27.9318 43.5009L29.3683 43.1824L29.0498 41.7459Z",
    fill: "#362D47"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6591 37.6922L28.2227 38.0107L28.5412 39.4472L29.9777 39.1287L29.6591 37.6922Z",
    fill: "#362D47"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5244 39.3748L27.0879 39.6934L27.4064 41.1298L28.8429 40.8113L28.5244 39.3748Z",
    fill: "#362D47"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3564 44.074L41.9199 44.3926L42.2385 45.8291L43.6749 45.5105L43.3564 44.074Z",
    fill: "#362D47"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6005 42.9559L40.1641 43.2744L40.4826 44.7109L41.9191 44.3923L41.6005 42.9559Z",
    fill: "#362D47"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8896 41.866L38.4531 42.1846L38.7717 43.621L40.2081 43.3025L39.8896 41.866Z",
    fill: "#362D47"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0986 40.7557L36.6621 41.0742L36.9807 42.5107L38.4171 42.1921L38.0986 40.7557Z",
    fill: "#362D47"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8349 35.0457L35.3984 35.3643L35.717 36.8007L37.1535 36.4822L36.8349 35.0457Z",
    fill: "#362D47"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0908 39.6043L22.6543 39.9229L22.9728 41.3593L24.4093 41.0408L24.0908 39.6043Z",
    fill: "#362D47"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6923 42.8963L22.2559 43.2148L22.5744 44.6513L24.0109 44.3328L23.6923 42.8963Z",
    fill: "#362D47"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M33.374 37.6219L31.9375 37.9404L32.256 39.3769L33.6925 39.0584L33.374 37.6219Z",
    fill: "#362D47"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2099 36.993L34.7734 37.3115L35.092 38.748L36.5285 38.4295L36.2099 36.993Z",
    fill: "#362D47"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8095 37.3035L33.373 37.6221L33.6916 39.0585L35.1281 38.74L34.8095 37.3035Z",
    fill: "#362D47"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3603 32.8025L31.9238 33.1211L32.2424 34.5576L33.6789 34.239L33.3603 32.8025Z",
    fill: "#362D47"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1962 32.1727L34.7598 32.4912L35.0783 33.9277L36.5148 33.6091L36.1962 32.1727Z",
    fill: "#362D47"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0693 31.5359L37.6328 31.8545L37.9514 33.291L39.3878 32.9724L39.0693 31.5359Z",
    fill: "#362D47"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M39.706 34.409L38.2695 34.7275L38.5881 36.164L40.0246 35.8455L39.706 34.409Z",
    fill: "#362D47"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3349 37.2459L38.8984 37.5645L39.217 39.0009L40.6535 38.6824L40.3349 37.2459Z",
    fill: "#362D47"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9716 40.119L39.5352 40.4375L39.8537 41.874L41.2902 41.5554L40.9716 40.119Z",
    fill: "#362D47"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7646 43.5848L37.3281 43.9033L37.6467 45.3398L39.0831 45.0213L38.7646 43.5848Z",
    fill: "#362D47"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4049 35.418L12.1387 29.708L17.8487 28.4418",
    stroke: "#4E2D92",
    strokeWidth: 0.853879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6618 27.8207L46.3955 22.1107L40.6855 23.377",
    stroke: "#4E2D92",
    strokeWidth: 0.853879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7276 50.6605L53.9938 56.3705L48.2838 57.6368",
    stroke: "#362D47",
    strokeWidth: 0.853879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4688 58.2588L19.735 63.9688L25.445 62.7026",
    stroke: "#4E2D92",
    strokeWidth: 0.853879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M50.849 35.5548L13.752 43.7812L13.8794 44.3558L50.9764 36.1294L50.849 35.5548Z",
    fill: "#06EA8C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7197 3.50747C20.0604 3.04949 19.7677 2.75681 19.3099 1.09762C19.2522 0.888617 19.0623 0.744141 18.8455 0.744141C18.6282 0.744141 18.4386 0.888511 18.381 1.09762C17.9229 2.75681 17.63 3.04949 15.9712 3.50747C15.7623 3.5652 15.6172 3.75507 15.6172 3.97194C15.6172 4.18871 15.7624 4.37848 15.9712 4.43642C17.63 4.8944 17.9229 5.18707 18.381 6.84616C18.4386 7.05495 18.6282 7.19985 18.8455 7.19985C19.0623 7.19985 19.2523 7.05495 19.3099 6.84616C19.7678 5.18697 20.0603 4.8943 21.7197 4.43642C21.9286 4.37869 22.0729 4.18871 22.0729 3.97194C22.0729 3.75518 21.9285 3.56531 21.7197 3.50747Z",
    fill: "#977BD2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96385 83.7428C5.30452 83.2848 5.01184 82.9922 4.55406 81.333C4.49631 81.124 4.30642 80.9795 4.08961 80.9795C3.87238 80.9795 3.6827 81.1239 3.62516 81.333C3.16706 82.9922 2.87417 83.2848 1.21536 83.7428C1.0064 83.8006 0.861328 83.9904 0.861328 84.2073C0.861328 84.4241 1.0065 84.6138 1.21536 84.6718C2.87417 85.1298 3.16706 85.4224 3.62516 87.0815C3.6827 87.2903 3.87238 87.4352 4.08961 87.4352C4.30642 87.4352 4.49641 87.2903 4.55406 87.0815C5.01194 85.4223 5.30441 85.1296 6.96385 84.6718C7.17271 84.614 7.31704 84.4241 7.31704 84.2073C7.31704 83.9905 7.17261 83.8007 6.96385 83.7428Z",
    fill: "#977BD2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7437 36.0839L17.4609 42.7432L21.6842 61.3142L50.967 54.6549L46.7437 36.0839Z",
    fill: "url(#paint0_linear_1321_1716)",
    fillOpacity: 0.62
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.609,
    cy: 16.422,
    r: 2.76673,
    fill: "#D3E1FC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.4191,
    cy: 17.3449,
    r: 2.76673,
    fill: "#4E2D92",
    fillOpacity: 0.28
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4373 88.7052C61.915 88.603 61.5741 88.0956 61.6762 87.5737L63.4599 78.4566C65.4067 68.5062 73.7239 60.9297 83.7894 59.8551L84.6474 55.6153C75.7069 50.8296 70.85 40.684 72.8015 30.7095L74.5852 21.5923C74.7913 20.5391 76.3162 20.5716 76.4837 21.6263L118.319 29.8113C118.873 28.8973 120.296 29.443 120.091 30.4953L118.307 39.6129C116.355 49.5865 108.033 57.1541 97.9485 58.2182L97.1448 62.4695C106.063 67.2582 110.912 77.4106 108.965 87.361L107.181 96.4786C106.948 97.6666 105.022 97.4691 105.311 95.9919L63.5917 87.8296C63.4687 88.458 63.0158 88.8193 62.4376 88.7062L62.4373 88.7052Z",
    fill: "#F5F7F8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M63.759 88.0973L105.055 96.1767C105.034 96.4973 105.109 96.7723 105.259 96.9893C105.442 97.2538 105.72 97.4094 106.01 97.4616C106.583 97.5649 107.262 97.2645 107.407 96.523L109.191 87.4053C111.147 77.4105 106.315 67.2158 97.4026 62.3469L98.1433 58.4288C108.251 57.2873 116.573 49.6744 118.533 39.6572L120.317 30.5396C120.562 29.2879 118.955 28.6184 118.216 29.5561L76.6757 21.4289C76.3448 20.2824 74.6041 20.2953 74.359 21.548L72.5752 30.6652C70.6152 40.6833 75.4547 50.8709 84.3875 55.737L83.5968 59.6444C73.507 60.7956 65.1891 68.4176 63.2336 78.4123L61.4499 87.5295C61.3329 88.1273 61.6849 88.7096 62.2501 88.8943L62.2531 88.905L62.3934 88.9325C62.7428 89.0009 63.069 88.9267 63.3261 88.7286C63.5251 88.5753 63.6714 88.3567 63.759 88.0973Z",
    stroke: "black",
    strokeOpacity: 0.16,
    strokeWidth: 0.461122
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4533 56.5851L84.6495 55.6149C76.8287 51.4285 72.1326 43.1403 72.3854 34.4536C97.5924 33.1615 96.924 45.5393 115.77 46.4921C112.143 52.9235 105.547 57.4166 97.9502 58.2176L97.7767 59.1343C95.1955 59.9537 92.593 60.7483 90.0778 61.7246C88.2331 59.9017 86.3211 58.2248 84.4528 56.585L84.4533 56.5851Z",
    fill: "#B1B1B1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.468 56.5065L84.4736 56.5076C77.1509 52.5877 72.7436 44.1796 72.3965 36.108C72.4652 36.1185 72.5362 36.1226 72.6083 36.118C97.631 34.5324 96.2344 46.9185 115.235 47.3925C111.516 53.3407 105.03 58.2785 97.7936 59.0419L97.7934 59.0428C95.2136 59.8674 92.6031 60.6502 90.0853 61.6275C88.2422 59.8064 86.3279 58.1408 84.4679 56.507L84.468 56.5065Z",
    fill: "#977BD2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.562 96.5188L87.5014 76.3205L65.0146 88.9771L103.562 96.5188Z",
    fill: "#977BD2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.538 31.7601L72.768 22.2185C71.1063 21.8934 70.0186 20.2765 70.3437 18.6148L70.7931 16.3177C71.1182 14.656 72.7351 13.5683 74.3968 13.8934L123.167 23.4351C124.829 23.7602 125.917 25.3771 125.592 27.0388L125.142 29.336C124.816 30.9985 123.2 32.0853 121.537 31.76L121.538 31.7601Z",
    fill: "#4E2D92"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.37 104.176L58.5999 94.634C56.9382 94.3089 55.8506 92.6916 56.1757 91.0299L56.6252 88.7327C56.9503 87.071 58.5671 85.9833 60.2288 86.3084L108.999 95.8501C110.661 96.1753 111.749 97.7922 111.424 99.4539L110.974 101.751C110.648 103.413 109.032 104.501 107.369 104.176L107.37 104.176Z",
    fill: "#4E2D92"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9595 68.0916C87.6872 67.8427 88.3521 66.1742 88.6418 64.6933C88.8855 63.4475 90.7775 63.8186 90.5339 65.0635C90.2435 66.5477 90.2313 68.3404 88.959 68.0915L88.9595 68.0916Z",
    fill: "#977BD2"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.6784 74.6453C86.4061 74.3964 87.071 72.728 87.3606 71.248C87.6043 70.0022 89.4962 70.3733 89.2527 71.6182C88.9627 73.1005 88.9502 74.8942 87.6779 74.6452L87.6784 74.6453Z",
    fill: "#977BD2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1321_1716",
    x1: 36.2437,
    y1: 57.7196,
    x2: 32.0204,
    y2: 39.1486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#DDFCEF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#B6F8DD",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7FF4C3",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#39EEA3",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06EA8C",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneAndLupa);
export default __webpack_public_path__ + "static/media/smartphone_and_lupa.c993a292f2614d94c03a92d5d5559456.svg";
export { ForwardRef as ReactComponent };